var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 852.92 151.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: .05em;\n      }\n\n      .cls-2 {\n        letter-spacing: .02em;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        font-family: KGBlankSpaceSolid, 'KG Blank Space Solid';\n        font-size: 87.01px;\n      }\n\n      .cls-4 {\n        fill: #18d609;\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        letter-spacing: -.13em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exports"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 852.92,
    height: 151.53,
    rx: 25,
    ry: 25
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(309.62 111.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 63.66,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 113.42,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 172.51,
    y: 0
  }, "Y"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.369e1a5fe39e50c91788826eb004e800.svg";
export { ForwardRef as ReactComponent };